<template>
  <el-main class="container">
    <!-- <el-form
      label-position="top"
      label-width="80px">
      <div class="title" v-if="type === 'set'">编辑分类</div>
      <div class="title" v-else>新增分类</div>
      <el-form-item label="排序序号">
        <el-input
          placeholder="请输入排序序号"
          v-model.trim="body.indexNum"
          @mousewheel.native.prevent
          clearable
          class="width"
          type="number"
          maxlength="100"/>
      </el-form-item>
      <el-form-item label="关联产业">
        <el-input
          placeholder="请输入分类名称"
          v-model.trim="body.name"
          clearable
          class="width"
          type="text"/>
      </el-form-item>
      <el-form-item label="分类名称">
        <el-select
          slot="prepend"
          class="select"
          placeholder="请选择分类">
          <el-option></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="pictureTitle">
        <UpLoadImg
          :img="picture"
          :size="[350, 180]"
          @get-files="getFiles"/>
      </el-form-item>
    </el-form> -->
    <div class="form-box">
      <div class="title" v-if="type === 'set'">编辑分类</div>
      <div class="title" v-else>新增分类</div>
      <div class="row">
        <div class="item">
          <div class="row-title">排序序号</div>
          <el-input
            placeholder="请输入排序序号"
            v-model.trim="body.indexNum"
            @mousewheel.native.prevent
            clearable
            class="width"
            type="number"/>
        </div>
      </div>

      <div class="row">
        <div class="item">
          <div class="row-title">分类名称</div>
          <el-input
            placeholder="请输入分类名称"
            v-model.trim="body.name"
            clearable
            class="width"
            type="text"/>
        </div>
        <div class="item">
          <div class="row-title">关联产业</div>
          <el-select
            v-model="selectIndustry"
            class="width"
            clearable
            placeholder="请选择产业"
          >
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="row">
        <div class="item">
          <div class="row-title">{{pictureTitle}}</div>
          <UpLoadImg
            tips="(100*100)"
            class="img"
            :img="picture"
            :size="[350, 180]"
            @get-files="getFiles"/>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <el-button @click="event().back()">取消</el-button>
      <el-button type="primary" @click="event().save()">保存</el-button>
    </div>
  </el-main>
</template>

<script>
import UpLoadImg from '@/components/upload-img'
import { setClassify, addClassify } from '@/api/serve'
import { getIndustrySelectList } from '@/api/industry'
export default {
  data() {
    return {
      tips: '(100*100)',
      body: {
        indexNum: '',
        name: '',
        picture: '',
        industryUuid: ''
      },
      type: '',
      picture: '',
      pictureTitle: '分类图片(0/1)',
      industryList: [],
      selectIndustry: ''
    }
  },
  created() {
    const { meta } = this.$route
    this.type = meta[meta.length - 1].url
    this.network().getIndustrySelectList()
  },
  mounted() {
    if (this.type === 'set') {
      this.picture = this.$route.query.info.picture
      this.selectIndustry = this.$route.query.info.industryUuid
      this.pictureTitle = '分类图片(1/1)'
      Object.assign(this.body, this.$route.query.info)
    }
  },
  methods: {
    event() {
      return {
        back: () => {
          this.$router.push('/serve-management/classify-management')
        },
        save: () => {
          this.body.industryUuid = this.selectIndustry
          if (!this.handlerVarifyBody()) return
          if (this.type === 'set') {
            this.network().setClassify()
          } else if (this.type === 'add') {
            this.network().addClassify()
          }
        }
      }
    },
    network() {
      return {
        setClassify: async() => {
          await setClassify(this.body)
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.$router.push('/serve-management/classify-management')
        },
        addClassify: async() => {
          await addClassify(this.body)
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.$router.push('/serve-management/classify-management')
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handlerVarifyBody() {
      if (!this.body.indexNum) {
        this.$message({
          message: '请填写序列号',
          type: 'warning'
        })
        return false
      } else if (!this.body.name) {
        this.$message({
          message: '请填写分类名称',
          type: 'warning'
        })
        return false
      } else if (this.body.industryUuid === '') {
        this.$message({
          message: '请选择产业',
          type: 'warning'
        })
        return false
      } else if (this.body.picture.length === 0) {
        this.$message({
          message: '请上传图片',
          type: 'warning'
        })
        return false
      }
      return true
    },
    getFiles(file, files) {
      this.body.picture = files.length ? file.response : ''
      files.length ? this.pictureTitle = '分类图片(1/1)' : this.pictureTitle = '分类图片(0/1)'
    }
  },
  components: {
    UpLoadImg
  }
}
</script>

<style scoped lang="scss">
.container{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .title{
    font-weight: bold;
    margin-bottom: 30px;
    font-size: 20px
  }
  .btn-box{
    display: flex;
    justify-content: center;
    button{
      margin: 0 15px;
    }
  }

  .form-box{
    .row{
      display: flex;
      .item{
        width: 700px;
        .row-title{

        }
        .width{
          margin: 25px 0;
          width: 400px;
        }
        .img{
          margin-top: 15px;
        }
      }
    }
  }
}
</style>
